import TasksAgenda from '../../features/tasks/layouts/agenda';

// TSS vite/01 §"Pages are thin".
export default function TasksPage() {
    return <TasksAgenda />;
}
